import { authRows, base64Bytes, saveBase64 } from '../../lib/mail.js'
import { formatBytes } from '../../lib/format.js'
import { fullDate } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- mail-raw ---
let __fez_component_0;
{
const SHOWN = 512 * 1024
__fez_component_0 = class {
  PROPS = {
    container: { type: String, required: true },
    mailbox: String,
    email: { type: String, required: true },
    view: Object,
  }

  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.source = ''
    this.state.export = null
    this.state.text = ''
    this.state.cut = ''
  }

  onRefresh(props, changed) {
    if ('email' in changed) this.load()
  }

  async load() {
    const email = this.props.email
    this.state.loading = true
    this.state.error = ''
    try {
      const exported = await window.App.api(`container/${this.props.container}/email_export`, { email, mailbox: this.props.mailbox || undefined }, { silent: true })
      if (email !== this.props.email) return
      const text = new TextDecoder().decode(base64Bytes(exported.data))
      this.state.export = exported
      this.state.text = text
      this.state.source = text.length > SHOWN ? text.slice(0, SHOWN) : text
      this.state.cut = text.length > SHOWN ? `Showing the first ${formatBytes(SHOWN)} of ${formatBytes(exported.size)}. Download or copy for the whole message.` : ''
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.loading = false
    }
  }

  download() {
    saveBase64(this.state.export.data, this.state.export.filename, 'message/rfc822')
  }

  async copy() {
    await navigator.clipboard.writeText(this.state.text)
    window.Toast?.success('Copied to the clipboard')
  }

  beforeRender() {
    const view = this.props.view
    const server = [view.helo, view.remote_ip].filter(Boolean).join(' ')
    this.state.rows = this.state.loading || this.state.error ? [] : [
      ['Received at', view.received_at ? fullDate(view.received_at) : ''],
      ['Delivered to', view.direction === 'in' ? view.address : ''],
      ['Envelope from', view.mail_from || ''],
      ['Sending server', server],
      ['Size', formatBytes(this.state.export?.size || 0)],
    ].filter(([, value]) => value).map(([label, value]) => ({ label, value }))
    this.state.auth = authRows(view.auth)
  }

  CSS = `:fez {
display:block;.raw-summary{display:grid;grid-template-columns:max-content minmax(0,1fr);gap:var(--space-1) var(--space-4);margin:0 0 var(--space-4);font-size:var(--text-sm)}.raw-label{color:var(--color-text-muted)}.raw-value{margin:0;overflow-wrap:anywhere}.raw-auth{display:flex;flex-wrap:wrap;gap:var(--space-2)}.raw-source{max-height:60vh;margin:0;padding:var(--space-3) var(--space-4);border:1px solid var(--color-border);border-radius:var(--radius-md);background:var(--color-bg-subtle);font-family:var(--font-mono);font-size:var(--text-xs);line-height:var(--leading-normal);white-space:pre-wrap;overflow-wrap:anywhere;overflow:auto}.raw-cut{margin-top:var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs)}.raw-actions{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:var(--space-2);margin-top:var(--space-3)}.raw-state{display:grid;place-items:center;min-height:160px}
}`

  HTML = `{#if state.error}
<div class="raw-state"><ui-empty icon="warning-circle" title="Could not load the source" text={state.error}></ui-empty></div>
{:else if state.loading}
<div class="raw-state"><ui-spinner></ui-spinner></div>
{:else}
<dl class="raw-summary">
{#each state.rows as row}
<dt class="raw-label">{row.label}</dt>
<dd class="raw-value">{row.value}</dd>
{/each}
{#if state.auth.length}
<dt class="raw-label">Authentication</dt>
<dd class="raw-value raw-auth">
{#each state.auth as row}
<ui-badge tone={row.tone} label={row.label}></ui-badge>
{/each}
</dd>
{/if}
</dl>
<pre class="raw-source">{state.source}</pre>
{#if state.cut}<p class="raw-cut">{state.cut}</p>{/if}
<div class="raw-actions">
<ui-button size="sm" icon="copy" label="Copy to clipboard" onclick="fez.copy()"></ui-button>
<ui-button size="sm" icon="download-simple" label="Download .eml" onclick="fez.download()"></ui-button>
</div>
{/if}`
};
}

Fez('mail-raw', __fez_component_0);

export default __fez_component_0;
